<div class="com-loading" [ngClass]="{'cl-web-ui': showWebUI && isWeb}">
    <ng-container *ngIf="loagingGif else baseLoading">
        <img class="com-loading-gif" [src]="loagingGif" alt="loading">
    </ng-container>
    <ng-template #baseLoading>
        <div class="com-loading-gif" [ngClass]="{'loading-bg-en': language === 'en','loading-bg-zh': language !== 'en'}"></div>
    </ng-template>
</div>

